module.exports = __webpack_public_path__ + "pattern6.88ab8ad95a8055d0f3dc.png";


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/assets/images/pattern6.png
// module id = ../../../../../src/assets/images/pattern6.png
// module chunks = styles